import { ofType } from 'redux-observable';
import { map, mergeMap,flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { TransformResponse } from './transform';

import {
    RESET,
} from 'one-state-subject/src/types';
import {
    Skeleton,
} from 'one-model-local';
import {
    setAction,
    reinitAction
} from 'one-state-calldest/src/action';
import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';
import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import {format} from 'one-util-date';
import { Disposition } from 'one-model-local';

export const enum Types {
    CALLERPATIENT = 'caller-patient',
    CALLERPROVIDER = 'caller-provider',
    SETCALLINGDEST = 'one-state-calling-destination/set',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushToSkeleton = (payload: any) => setSkeletonAction(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

/**
 * This Function will fetch the data of calling destination
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchCallingDest = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(),'LT');
        const errorDate = format(new Date(),'LL');
        const { server, agentId,teamName, alertnotification, settings: { compatible, epicendpoints: { getentity, apitoken } }, log } = context;
        const { contact_center_type } = compatible;
        return action$.pipe(
            ofType(Types.CALLERPATIENT, Types.CALLERPROVIDER),
            //todo: to fix the type of Action
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the data response
                 */

                let dataresponse = action.payload;
                const getRequest = (payload: any) => {
                    if (payload) {
                        let headers = new Headers();
                        headers.set('Authorization', 'Basic ' + apitoken?.token);

                        const response = server.get({
                            path: getentity + "?phone=" + (payload.dnis ? payload.dnis : "") + "",
                            headers: headers
                        })
                            .then((calledresponse: any) => calledresponse[0])
                            .catch((callederror: any) => {
                                log.error(
                                    "ccw-gadget,callingdestination-epic",
                                    "fetch-CallingDest-epic-error", {
                                    callederror
                                }
                                );
                                    // SEND to ALERT notificaiton/NOC servers for critical error on no active server
                                    if(callederror?.status === 0) {
                                        if(alertnotification?.isEnabled()){
                                            var timestamp=new Date().toJSON();
                                            alertnotification.notify({
                                                "error_code" : "930-31" ,
                                                "error_type": "SERVER_ERROR" ,
                                                "error_description": "Unable to reach active servers",
                                                "error_supertype":"SERVER_FAILS",
                                                "error_detail": "Unable to reach any of server for retring data ",
                                                "alert":"Yes",
                                                "timestamp": timestamp ,
                                                "params":callederror
                                            });
                                        }
                                    }

                                let calldesterror: ErrorObject = {
                                    source: "CalledDest",
                                    type: "error",
                                    status: callederror?.status,
                                    erroritems: callederror?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return calldesterror;
                            })
                        log.debug(
                            "ccw-gadget,callingdestination-epic",
                            "fetch-CallingDest-epic", {
                            response
                        }
                        );
                        return from(response)
                    } else {
                        return from([]);
                    }
                }
                //the reason is we need to use pipe function.
                return getRequest(dataresponse).
                    pipe(
                        map((response: any) => TransformResponse(response, context))).
                    pipe(
                        flatMap(response => {
                            const actions: any = [
                                setAction(response)
                            ];
                            //clear skeleton for callerdestination
                            let skeletoncallerdest: Skeleton = {
                                callingDestination_skeleton: false
                            }
                            actions.push(pushToSkeleton(skeletoncallerdest));
                            if (response.error) {
                                actions.push(addAction(response.error));
                                let disp: Disposition = { value: "999" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = response?.error?.status;
                                disp.meta03 = response?.error?.erroritems[0]?.error_detail;
                                disp.meta04 = 'client';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "182" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value.choosecaller?.callId;
                                }
                                disp.meta02 = '200';
                                disp.meta03 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);
/**
 * This Function will clear data of calling destination epic
 * subsequent redux action
 * @param context contains the settings,logger etc..
 */
export const clearCalledDestination = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget,callingdestination-epic",
            "Reset-Calling-Destination-epic", {
        });
        return action$.pipe(
            ofType(RESET),
            map(action => reinitAction())
        )
    }
);
